__turbopack_context__.v({
  "accepted": "wallet-offers-module__32Wy3G__accepted",
  "card": "wallet-offers-module__32Wy3G__card",
  "chevronOpen": "wallet-offers-module__32Wy3G__chevronOpen",
  "declined": "wallet-offers-module__32Wy3G__declined",
  "empty": "wallet-offers-module__32Wy3G__empty",
  "expanded": "wallet-offers-module__32Wy3G__expanded",
  "itemName": "wallet-offers-module__32Wy3G__itemName",
  "list": "wallet-offers-module__32Wy3G__list",
  "manager": "wallet-offers-module__32Wy3G__manager",
  "peek": "wallet-offers-module__32Wy3G__peek",
  "peekAmount": "wallet-offers-module__32Wy3G__peekAmount",
  "peekCopy": "wallet-offers-module__32Wy3G__peekCopy",
  "tabs": "wallet-offers-module__32Wy3G__tabs",
  "thumbnail": "wallet-offers-module__32Wy3G__thumbnail",
  "wallet": "wallet-offers-module__32Wy3G__wallet",
});
